const useFileDownload = () => {
  const downloadFile = async (url: string, filename?: string) => {
    try {
      const link = document.createElement("a");
      link.href = url;
      if (filename) {
        link.download = filename;
      }
      link.click();
    } catch (error) {
      console.error("Error downloading file:", error);
    }
  };
  return downloadFile;
};

export default useFileDownload;
